<template>
  <div ref="dom" @scroll="handleScroll($event)" class="box">
    <Header ref="headerNav" isActive="about" />
    <div class="content">
      <div class="topimg">
        <span>关于我们</span>
        <b>ABOUT US</b>
      </div>
      <div class="nav">
        <ul>
          <li><a @click="togsjj" href="#">公司简介</a></li>
          <li><a @click="toqywh" href="#">企业文化</a></li>
          <li><a @click="toryzz" href="#">荣誉资质</a></li>
          <li><a @click="tofzlc" href="#">发展历程</a></li>
          <li><a @click="tolxwm" href="#">联系我们</a></li>
        </ul>
      </div>
      <div class="main-body">
        <span>公司简介</span>
        <div class="line"></div>
        <div class="wrap-p">
          <p
            style="text-indent: 2em"
            v-for="(item, index) in info.content"
            :key="index"
          >
            {{ item }}
          </p>
        </div>

        <div class="video">
          <div v-if="toplay === true" class="play-btn">
            <img
              @click="videoplay"
              src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/about-we/video-play.png"
              alt=""
            />
          </div>
          <video
            ref="play"
            controls
            :autoplay="false"
            :src="info.video"
          ></video>
        </div>
        <span>企业文化</span>
        <div class="line"></div>
        <div class="Total-box">
          <div class="left-box">
            <div class="top" v-if="wenhua[0]" :style="{backgroundImage:'url(' + wenhua[0].imgUrl +')',}">
              <b>{{wenhua[0].title}}</b>
              <i>{{wenhua[0].content}}</i>
            </div>
            <div class="top" v-else></div>
            <div class="bottom" v-if="wenhua[1]" :style="{backgroundImage:'url(' + wenhua[1].imgUrl +')',}">
              <b>{{wenhua[1].title}}</b>
              <i>{{wenhua[1].content}}</i>
            </div>
            <div class="bottom" v-else></div>
          </div>
          
          <div class="center-box" v-if="wenhua[2]" :style="{backgroundImage:'url(' + wenhua[2].imgUrl +')',}">
            <b>{{wenhua[2].title}}</b>
            <i>{{wenhua[2].content}}</i>
          </div>
          <div class="center-box" v-else></div>
          <div class="right-box" >
            <div class="top" v-if="wenhua[3]" :style="{backgroundImage:'url(' + wenhua[3].imgUrl +')',}">
              <b>{{wenhua[3].title}}</b>
              <i>{{wenhua[3].content}}</i>
            </div>
            <div v-else class="top"></div>
            <div class="bottom" v-if="wenhua[4]" :style="{backgroundImage:'url(' + wenhua[4].imgUrl +')',}">
              <b>{{wenhua[4].title}}</b>
              <i
                >{{wenhua[4].content}}</i
              >
            </div>
            <div v-else class="bottom"></div>
          </div>
          
        </div>

        <span>荣誉资质</span>
        <div class="line"></div>
        <p class="ryzz">
          拥有丰富的软件著作权证书和软件产品,
          整合国内外优质创业指导课程、领先的实训方法和工具、科学的专业测评体系、丰富的实践学习资源和优质的创业保障资源。
        </p>
        <div class="loop-box">
          <div class="toleft" @click="toprev"></div>
          <div class="toright" @click="tonext"></div>
          <div class="loop-top">
            <span :class="{ active: isactive === 1 }" @click="select1"
              >政策支持</span
            >|
            <span :class="{ active: isactive === 2 }" @click="select2"
              >资质</span
            >|
            <span :class="{ active: isactive === 3 }" @click="select3"
              >奖项</span
            >
          </div>

          <el-carousel
            class="looppage"
            ref="loops"
            height="416px"
            indicator-position="none"
            arrow="never"
            :autoplay="false"
          >
            <el-carousel-item
              class="loop-item"
              v-for="item in DataList"
              :key="item.id"
            >
              <div v-for="i in item" :key="i.id">
                <img :src="i.certificateImg" alt="" />
                <span>{{ i.title }}</span>
                <div>{{ i.title }}</div>
              </div>

              <!-- content -->
            </el-carousel-item>
          </el-carousel>
        </div>

        <div class="Company-history">
          <span style="color: #ffffff">发展历程</span>
          <div class="own-line"></div>
          <div class="history-box">
            <img
              @click="hisToleft"
              class="toleft"
              src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/about-we/toleft-small.png"
              alt=""
            />
            <img
              @click="hisToright"
              class="toright"
              src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/about-we/toright-small.png"
              alt=""
            />
            <el-carousel
              class="hidtory-loop"
              ref="historyloop"
              height="400px"
              indicator-position="none"
              arrow="never"
              :initial-index="num"
              :autoplay="false"
            >
              <el-carousel-item v-for="(item,index) in fazhan" :key="index" class="history-item">
                <div v-for="(item1,index1) in item" :key="index1">
                  <b>{{item1.timeKey}}</b>
                  <div>
                    <img
                      @click="changepoint(9)"
                      src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/about-we/point.png"
                      alt=""
                      id="9"
                    />
                  </div>
                  <span
                    v-for="(item2,index2) in item1.eventValue"
                    :key="index2"
                    ><img
                      src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/about-we/little-point.png"
                      alt=""
                    />
                    {{item2}}</span
                  >
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>

        <span>联系我们</span>
        <div class="line"></div>

        <div class="map-box">
          <img
            class="location-point"
            src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/about-we/location-point.png"
            alt=""
          />
          <img
            class="qipaokuang"
            src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/about-we/qipaokuang.png"
            alt=""
          />
          <div class="box">
            <i>电话:{{ info.phone }}</i
            ><i>邮箱:{{ info.email }}</i
            ><i>地址:{{ info.address }}</i
            ><img
              class="left-map"
              src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/about-we/blue-map.png"
              alt=""
            />
          </div>
          <img
            class="phone"
            src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/about-we/phone.png"
            alt=""
          />
          <img
            class="email"
            src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/about-we/email.png"
            alt=""
          />
          <img
            class="location"
            src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/about-we/zuobiao.png"
            alt=""
          />
          <b>启创未来(北京)科技有限公司</b>
          <i
            >地址:北京市海淀区西三旗建材城东路18号<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            佰能大厦2层</i
          >
        </div>
      </div>
      <Footer class="footer" />
    </div>
    <!-- <div class="null-box"></div> -->
    <!-- <Footer/> -->
  </div>
</template>

<script>
// let
import { getZizhiData, getHistory, getHome,getFazhan,getWenhua } from "@/api/index.js";
let flag = "";
export default {
  name: "AboutWe",
  data() {
    return {
      toplay: true,
      isactive: 1,
      num: 0,
      DataList: [],
      pointimg: "",
      historyData: [],
      info: {},
      wenhua:[],
      fazhan:[]
    };
  },
  mounted() {
    this.getZizhiData(1);
    this.getHistoryData();
    // this.handleScroll()
    // window.addEventListener('scroll', this.handleScroll
    getFazhan().then(res => {
      console.log(res,'发展');
      if (res.status == 200) {
        res.data.forEach(item => {
          item.eventValue = item.eventValue.split('；')
        });
        this.fazhan = this.splitArr(res.data)
        console.log(this.fazhan,'asdasd');
      }
    })
    getWenhua().then(res => {
      console.log(res,'文化');
      if (res.status == 200) {
        this.wenhua = res.data
      }
    })
    getHome().then((res) => {
      console.log(res);
      if (res.status == 200) {
        this.info = res.data;
        this.info.content = this.info.content.split("；");
      }
    });
  },
  methods: {
    splitArr(ar, size = 4) {
      let index = 0;
      let res = [];
      while (index < ar.length) {
        res.push(ar.slice(index, index + size));
        index += size;
      }
      return res;
    },
    handleScroll(e) {
      if (e.srcElement.scrollTop > 2) {
        this.$refs.headerNav.showHeadBj();
      } else {
        this.$refs.headerNav.hideHeadBj();
      }
      //滚动事件
      // console.log('eeeeeeeee', e.srcElement.scrollTop, e.target.scrollTop)
    },
    async getHistoryData() {
      const res = await getHistory();
      this.historyData = res.data;
      console.log("lishi", this.historyData);
    },
    changepoint(id) {
      console.log(id);
      if (flag != null && flag != "")
        document
          .getElementById(flag)
          .setAttribute(
            "src",
            "https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/about-we/point.png"
          );

      document
        .getElementById(id)
        .setAttribute(
          "src",
          "https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/bluepoint.png"
        );
      // console.log(id)
      flag = id;
    },
    async getZizhiData(type) {
      const res = await getZizhiData(type);
      this.DataList = res.data;
      // console.log('22222', res)
    },
    togsjj() {
      this.$refs.dom.scrollTo(0, 700);
    },
    toqywh() {
      this.$refs.dom.scrollTo(0, 1750);
    },
    toryzz() {
      this.$refs.dom.scrollTo(0, 2650);
    },
    tofzlc() {
      this.$refs.dom.scrollTo(0, 3400);
    },
    tolxwm() {
      this.$refs.dom.scrollTo(0, 4100);
    },
    videoplay() {
      this.toplay = false;
      this.$refs.play.play();
    },
    select1() {
      // this.$refs.loops.setActiveItem(0)
      this.getZizhiData(1);
      this.isactive = 1;
      // console.log(this.pageNum)
    },
    select2() {
      this.getZizhiData(2);
      // this.$refs.loops.setActiveItem(1)
      this.isactive = 2;
      // console.log(this.pageNum)
    },
    select3() {
      this.getZizhiData(3);
      // this.$refs.loops.setActiveItem(2)
      this.isactive = 3;
      // console.log(this.pageNum)
    },
    toprev() {
      this.$refs.loops.prev();
    },
    tonext() {
      this.$refs.loops.next();
    },
    hisToleft() {
      if (this.num === 0) {
        return;
      } else {
        this.$refs.historyloop.prev();
        this.num--;
      }
    },
    hisToright() {
      if (this.num === this.fazhan.length - 1) {
        return;
      } else {
        this.$refs.historyloop.next();
        this.num++;
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep Footer {
  position: static;
}
.map-box {
  width: 1225px;
  height: 525px;
  margin: 0 auto;
  margin-bottom: 80px;
  margin-top: 68px;
  background-image: url("https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/about-we/map.png");
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  b {
    position: absolute;
    top: 109px;
    right: 252px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 600;
    color: #1c43bd;
    line-height: 26px;
  }
  i {
    position: absolute;
    top: 138px;
    right: 224px;
    font-style: normal;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 21px;
  }
  .location-point {
    position: absolute;
    width: 25px;
    right: 336px;
    top: 203px;
  }
  .qipaokuang {
    width: 309px;
    position: absolute;
    right: 193px;
    top: 91px;
  }
  .box {
    position: relative;
    width: 440px;
    height: 500px;
    margin-top: 12px;
    background-image: url("https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/about-we/blue-map.png");
    background-repeat: no-repeat;
    background-size: cover;
    overflow: hidden;
    i:nth-child(1) {
      position: absolute;
      right: 80px;
      top: 83px;
      font-style: normal;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      line-height: 26px;
    }
    i:nth-child(2) {
      position: absolute;
      right: 80px;
      top: 230px;
      font-style: normal;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      line-height: 26px;
    }
    i:nth-child(3) {
      position: absolute;
      left: 100px;
      top: 354px;
      font-style: normal;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      line-height: 26px;
      width: 273px;
    }
    
  }
  .phone {
    width: 76px;
    position: absolute;
    left: 400px;
    top: 85px;
  }
  .email {
    width: 76px;
    position: absolute;
    left: 400px;
    top: 220px;
  }
  .location {
    width: 76px;
    position: absolute;
    left: 400px;
    bottom: 97px;
  }
}
.history-box {
  width: 1400px;
  margin: 0 auto;
  position: relative;
}
.Company-history {
  width: 100%;
  height: 600px;
  margin-top: 100px;
  background-image: url("https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/mountainbg.png");
  background-repeat: no-repeat;
  background-size: cover;
  // display: flex;
  text-align: center;
  position: relative;
  .toleft {
    width: 22px;
    height: 40px;
    position: absolute;
    top: 189px;
    left: -4px;
    z-index: 3;
  }
  .toright {
    width: 22px;
    height: 40px;
    position: absolute;
    top: 189px;
    right: -4px;
    z-index: 3;
  }
  span {
    line-height: 219px;
  }
  .own-line {
    margin: 0 auto;
    width: 120px;
    height: 4px;
    background: #f4930f;
    margin-top: -50px;
  }
  .hidtory-loop {
    margin: 0 auto;
    width: 1276px;
    // background-color: rgba(255, 0, 0, 0.603);
    .history-item {
      div {
        float: left;
        height: 100%;
        width: 319px;
        display: flex;
        flex-direction: column;
        // justify-content: center;
        align-items: center;
        div {
          margin-top: 32px;
          height: 2px;
          background-color: #fff;
          position: relative;
          img {
            position: absolute;
            width: 38px;
            top: -18px;
          }
        }
        b {
          margin-top: 143px;
          font-size: 22px;
          font-family: Microsoft YaHei;
          font-weight: 600;
          color: #ffffff;
        }
        span {
          line-height: 29px;
          margin-top: 34px;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
          text-align: left;
          position: relative;
          width: 270px;
          margin-bottom: 15px;
          // overflow:auto;
          text-overflow: ellipsis;
          // display:-webkit-box;
          // -webkit-box-orient:vertical;
          // -webkit-line-clamp:2;
          img {
            position: relative;
            top: -2px;
            right: 3px;
            width: 8px;
          }
        }
      }
    }
  }
}
.looppage {
  position: absolute;
  bottom: 0;
  // background-color: red;
  width: 100%;
  .loop-item {
    display: flex;
    justify-content: center;
    div {
      position: relative;
      width: 278px;
      height: 380px;
      margin-right: 30px;
      padding-bottom: 10px;
      // background-color: #ccc;
      text-align: center;
      img {
        width: 100%;
        height: 100%;
        background-color: rgb(231, 226, 226);
      }
      span {
        // display: b;
        z-index: 222;
        width: 100%;
        height: 40px;
        padding: 10px;
        // background-color: red;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #333333;
        opacity: 1;
        transition: 0.4s;
      }
      div {
        // display: none;
        position: absolute;
        width: 100%;
        padding: 0 10px 0 10px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        text-align: center;
        display: block;
        bottom: -36px;
        height: 70px;
        background: #1c43bd;
        opacity: 0;
        color: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: 400;
        transition: 0.4s;
        // line-height: 70px;
      }
    }
    div:hover {
      div {
        opacity: 0.9;
        transition: 0.4s;
      }
      span {
        opacity: 0;
        transition: 0.4s;
      }
    }
    #last-child {
      margin-right: 0px;
    }
    // div:hover {
    //   div {

    //   }
    // }
  }
}
.loop-box {
  position: relative;
  margin-top: -126px;
  width: 1420px;
  height: 490px;
  // background-color: #f4f4f4;
  .toleft {
    position: absolute;
    background-image: url("https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/about-we/toleft-small.png");
    left: 0;
    top: 239px;
    z-index: 3;
    background-repeat: no-repeat;
    width: 22px;
    height: 40px;
  }
  .toright {
    z-index: 3;
    background-image: url("https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/about-we/toright-small.png");
    position: absolute;
    right: 0;
    top: 239px;
    background-repeat: no-repeat;
    width: 22px;
    height: 40px;
  }
  .loop-top {
    text-align: center;
    -webkit-box-pack: center;
    height: 75px;
    // display: flex;
    // // align-items: center;
    // justify-content: center;
    font-size: 25px;
    color: #cccccc;
    span {
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      line-height: 30px;
      margin: 0 25px 0 15px;
    }
    span.active {
      cursor: default;
      color: #1c43bd;
    }
    span:hover {
      cursor: pointer;
    }
  }
}
.Total-box {
  margin-top: 70px;
  width: 100%;
  height: 640px;
  background-color: #f4f4f4;
  display: flex;

  div {
    // border: 1px dashed #888888;
    float: left;
  }
  b {
    margin-top: -10px;
    font-size: 22px;
    font-family: Microsoft YaHei;
    font-weight: 600;
    color: #ffffff;
  }
  i {
    font-style: normal;
    margin-top: 20px;
    width: 240px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
  }
  .right-box {
    flex: 1;
    height: 640px;
    display: flex;
    flex-direction: column;
    .top {
      height: 320px;
      width: 100%;
      // background-color: rgb(93, 57, 223);
      background-size: cover;
      background-repeat: no-repeat;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      text-align: center;
    }
    .bottom {
      width: 100%;
      height: 320px;
      // background-color: red;
      background-size: cover;
      background-repeat: no-repeat;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      text-align: center;
    }
  }
  .left-box {
    flex: 1;
    height: 640px;
    display: flex;
    flex-direction: column;

    .top {
      height: 320px;
      width: 100%;
      // background-color: rgb(93, 57, 223);
      background-size: cover;
      background-repeat: no-repeat;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      text-align: center;
    }
    .bottom {
      width: 100%;
      height: 320px;
      // background-color: red;
      background-size: cover;
      background-repeat: no-repeat;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      text-align: center;
    }
  }
  .center-box {
    flex: 1;
    height: 640px;
    background-size: cover;
    background-repeat: no-repeat;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
  }
}
.main-body {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  span {
    margin-top: 90px;
    width: 144px;
    height: 34px;
    font-size: 36px;
    font-family: Microsoft YaHei;
    font-weight: 600;
    color: #333333;
  }
  .line {
    margin-top: 45px;
    width: 120px;
    height: 4px;
    background: #f4930f;
  }
  p.ryzz {
    margin-top: 45px;
    width: 1100px;
    height: 197px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 30px;
    margin-bottom: 4%;
    p {
      margin: 0;
    }
  }
  div.wrap-p {
    margin-top: 45px;
    width: 1100px;
    height: 197px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 30px;
    margin-bottom: 4%;
    p {
      margin: 0;
    }
  }

  .video {
    position: relative;
    margin-top: 30px;
    width: 1000px;
    height: 588px;
    // background-image: url("https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/video_cover.jpeg");
    background-repeat: no-repeat;
    background-size: contain;
    .play-btn {
      z-index: 1;
      position: absolute;
      background-image: url("https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/video_cover.jpeg");
      background-repeat: no-repeat;
      background-size: contain;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 98px;
        height: 98px;
      }
    }
    video {
      width: 100%;
      height: 100%;
    }
  }
}
.box {
  width: 100%;
  height: 100vh;
  // position: relative;
  overflow: scroll;
}
.null-box {
  width: 100%;
  height: 300px;
}
.topimg {
  width: 100%;
  height: 580px;
  background-image: url("https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/about-we/组 20.png");
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  span {
    font-size: 42px;
    font-family: Microsoft Yahei;
    font-weight: 400;
    color: #ffffff;
  }
  b {
    font-size: 40px;
    font-family: Microsoft JhengHei;
    font-weight: 400;
    color: #006cda;
  }
}
.nav {
  width: 100%;
  height: 60px;
  background: #f4f4f4;
  display: flex;
  justify-content: center;
  align-items: center;
  li {
    margin-right: 80px;
    line-height: 60px;
    float: left;
    list-style: none;
    width: 64px;
    height: 60px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    a {
      text-decoration: none;
      color: #666666;
    }
  }
  li:hover {
    border-bottom: 2px solid #1c43bd;
    color: #1c43bd;
    a {
      color: #1c43bd;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/about-we.vue